/* eslint-disable import/prefer-default-export */
import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';

export async function getLogSearch(params) {
  return request(`${url.salaryApi}/salary/operate/salaryLog?${stringify(params)}`);
}
